// Simple layout with React Router navigation
import { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Logo } from './Logo';
import { Navigation } from './Navigation';
interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const location = useLocation();

  return (
    <div className='min-h-screen bg-gray-50'>
      {/* Header */}
      <header className='bg-white shadow'>
        <div className='mx-auto px-4 sm:px-6 lg:px-8'>
          <div className='flex justify-between items-center py-6'>
            <Logo />
            {/* Navigation */}
            <Navigation />
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className='mx-auto py-6 sm:px-6 lg:px-8'>{children}</main>

      {/* Footer */}
      <footer className='text-center text-xs text-gray-500 py-2'>
        {' '}
        v2.1.0 - React Router + Zustand + React Query
      </footer>
    </div>
  );
}
